import { Box, Typography, makeStyles } from '@material-ui/core';
import { CSSProperties, ReactNode } from 'react';
import { WbButton } from '../../WbButton';

type FilterGroupProps = {
  style?: CSSProperties;
  label: ReactNode;
  hideShowMore?: boolean;
  onShowMore?: () => void;
  children: ReactNode;
  /**
   * If defined, the label acts as an html label for the element with same id
   */
  labelFor?: string;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(0.5),
      },
    },
    label: {
      fontWeight: 700,
      color: theme.palette.secondary.dark,
      textTransform: 'uppercase',
    },
    filters: {},
  }),
  { name: 'FilterGroup' },
);

export const FilterGroup = ({
  label,
  style,
  hideShowMore,
  onShowMore,
  children,
  labelFor,
}: FilterGroupProps) => {
  const classes = useStyles();

  const getLabel = () => {
    if (typeof label !== 'string') return label;
    // acts as html label
    if (labelFor)
      return (
        <Typography
          variant="body2"
          component="label"
          htmlFor={labelFor}
          className={classes.label}
        >
          {label}
        </Typography>
      );
    return (
      <Typography variant="body2" className={classes.label}>
        {label}
      </Typography>
    );
  };

  return (
    <Box className={classes.root} style={style}>
      {getLabel()}
      {children}
      {onShowMore && !hideShowMore && (
        <WbButton
          style={{ alignSelf: 'flex-start' }}
          variant="text"
          label="Show More"
          onClick={onShowMore}
        />
      )}
    </Box>
  );
};
